import mapKnownValues from "../../utils/mapKnownValues";
import { Role } from "./user";

export default class Signup {
  firstName = "";
  lastName = "";
  companyName = "";
  email = "";
  phoneNumber = "";
  password = "";
  confirmPassword = "";
  agreeToTerms = false;
  role: Role = Role.Admin;

  constructor(params: Partial<Signup> = {}) {
    mapKnownValues(this, params);
  }

  toJSONForAPI() {
    return JSON.stringify({
      ...this,
      role: this.role || Role.Admin,
    });
  }
}
